<p-card
  [styleClass]="'m-0 w-full ' + (!isPPG() ? 'border-none' : 'ppg-card')"
  [class]="'m-0 color-chip text-center ' + styleClass()"
  [ngClass]="{ 'invalid-color-chip-body': !color().isValid }">
  @if (!color().isValid) {
    <div class="color-image-unavailable">
      <img [src]="defaultImage" alt="Color Image Unavailable" />
      <p>{{ resources.colorNumberNotAvailable | resourceValue: { 'Color EMG number': color().productNumber } }}</p>
    </div>
  } @else {
    <div class="color-chip-body" ppgBackground [imageUrl]="colorValid().image" [rgb]="colorValid().rgb">
      @if (!isVisualizable()) {
        <div class="color-image-unavailable">
          <img [src]="defaultImage" alt="Color Image Unavailable" />
          <p>{{ resources.colorNotAvailable | resourceValue }}</p>
        </div>
      }
      <!-- There are 2 p-buttons, as the conditional statement for [icon] is not working properly. Could be updated after https://dev.azure.com/ppgit/PPG%20Design%20System/_workitems/edit/1009252 is fixed -->
      @if (color().isFavorite) {
        <p-button
          ppgFontColorBasedOnBackground
          [backgroundRGB]="isPPG() ? '255, 255, 255' : colorValid().rgb"
          [darkFontColorValue]="'var(--fg-secondary)'"
          [styleClass]="'favorite-button ' + (isHistor() ? 'button-raised' : isAlcro() ? 'button-icon-only' : '')"
          [icon]="PrimeIcons.HEART_FILL"
          [text]="true"
          (onClick)="onFavoriteButtonClicked()"
          [attr.data-test-id]="'colorChip.invalidColor.favoriteButton.' + color().productNumber" />
      } @else {
        <p-button
          ppgFontColorBasedOnBackground
          [backgroundRGB]="isPPG() ? '255, 255, 255' : colorValid().rgb"
          [darkFontColorValue]="'var(--fg-secondary)'"
          [styleClass]="'favorite-button ' + (isHistor() ? 'button-raised' : isAlcro() ? 'button-icon-only' : '')"
          [icon]="PrimeIcons.HEART"
          [text]="true"
          severity="secondary"
          (onClick)="onFavoriteButtonClicked()"
          [attr.data-test-id]="'colorChip.invalidColor.favoriteButton.' + color().productNumber" />
      }
    </div>
  }
  @if (color().isValid) {
    <ng-template pTemplate="footer">
      <p-button
        [attr.data-test-id]="'colorChip.validColor.favoriteButton.' + colorValid().colorName"
        [styleClass]="'w-full h-full p-0 ' + (isHistor() ? '' : 'text-left ') + (isPPG() ? 'font-bold' : '')"
        [label]="colorValid().colorName"
        [link]="true"
        [routerLink]="colorDetailsLink()"
        (onClick)="onColorDetailsLinkClicked()"></p-button>
      @if (colorValid().colorCode) {
        <p [class]="'color-code ' + (isHistor() ? '' : 'text-left')">{{ colorValid().colorCode }}</p>
      }
    </ng-template>
  }
</p-card>
